import React, {useState, useEffect} from 'react';
import Icon from '../app_components/Icon';
import Search from '../form_sections/Search';

export default function SearchUsers(props) {
  const [text, setText] = useState("")
  const [users, setUsers] = useState([])
  const [selectedUser, setSelectedUser] = useState([])
  const [page, setPage] = useState(0)

  useEffect(() => {
    setPage(0)
    searchUsersByText()
  }, [text])

  useEffect(() => {
  }, [selectedUser])

  useEffect(() => {
    searchUsersByText()
  }, [page])

  function searchUsersByText() {
    $.ajax({
      url: `../search_users_by_text`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        text: text,
        page: page
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        setUsers(JSON.parse(data.data.users))
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  function getUser(user) {
    setSelectedUser(user)
  }

  function renderUsers() {
    return users.map((user) => {
      return(
        <tr key={user.id} style={{marginTop: 10}}>
          <td style={{verticalAlign: 'middle'}}><img src={user.avatar_url} className="user_image" style={{height: 25, width: 25, borderRadius: '100%'}}/></td>
          <td style={{verticalAlign: 'middle'}}><p>{user.preferred_name}</p></td>
          <td style={{verticalAlign: 'middle'}}><p>{user.email}</p></td>
          <td style={{verticalAlign: 'middle'}}><p className={user.status === 'Cancelled' ? 'red' : 'darkBlue'}>{user.status}</p></td>
          <td style={{verticalAlign: 'middle', textAlign: 'end'}}>
            <button type="button" className="lex-btn lex-btn--secondary lex-btn--small" onClick={() => getUser(user)}>select</button>
          </td>
        </tr>
      )
    })
  }

  function adminUpdateUser(userId, data) {
    $.ajax({
      url: `../adminUpdateUser`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        id: userId,
        user: {
          ...data
        }
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        console.log('success')
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  function cancelUser(id) {
    let data = {
      status: 'Cancelled',
      cancel_reason: 'Admin Cancelled'
    }
    adminUpdateUser(id, data)
  }

  function restoreUser(id) {
    let data = {
      status: 'Active',
      cancel_reason: ''
    }
    adminUpdateUser(id, data)
  }

  function requestFullDelete(id) {
    $.ajax({
      url: `../admin_request_full_delete`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        userId: id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        console.log('success')
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }


  return (
    <div className="admin_section_outline">

      {selectedUser != 0 &&
        <div>
          <button type="button" className="lex-btn lex-btn--ghost" onClick={() => setSelectedUser([])}>{`< back`}</button>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 10}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <img src={selectedUser.avatar_url} className="user_image" style={{height: 50, width: 50, borderRadius: '100%'}}/>
              <div style={{paddingLeft: 10}}>
                <p style={{paddingBottom: 10}}>{selectedUser.preferred_name}</p>
                <p>{selectedUser.email}</p>
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
              {selectedUser.status != "Cancelled" && <button type="button" className="lex-btn lex-btn--destructive lex-btn--small" onClick={() => cancelUser(selectedUser.id)}>cancel account</button>}
              {selectedUser.status === "Cancelled" && <button type="button" className="lex-btn lex-btn--secondary lex-btn--small" onClick={() => restoreUser(selectedUser.id)}>restore account</button>}
              <button type="button" className="lex-btn lex-btn--destructive lex-btn--small" onClick={() => requestFullDelete(selectedUser.id)}>request full delete</button>
            </div>
          </div>
          <div style={{display: 'flex', marginTop: 15}}>
            <div>
              <p className="bold">Subscription</p>
            </div>
            <div style={{marginLeft: 15}}>
              <p className="bold">Purchases</p>
            </div>
          </div>
        </div>
      }
      {selectedUser.length == 0 &&
        <div>
          <div style={{display: 'flex', flexDirection: 'row', flex: 1, gap: 10, alignItems: 'center'}}>
            <Search
              value={text}
              placeholder="search for user..."
              onChange={(value) => setText(value)}
            />
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginLeft: 10,
              width: 50,
              alignItems: 'center'
            }}>
              <button
                style={{cursor: 'pointer'}}
                disabled={page === 0}
                onClick={() => setPage(page-1)}>
                <Icon name="arrow-left" size={12} />
              </button>
              <h5>{page}</h5>
              <button
                style={{cursor: 'pointer'}}
                disabled={users.length < 5}
                onClick={() => setPage(page+1)}>
                <Icon name="arrow-right" size={12} />
              </button>
            </div>
          </div>
          <table className="admin_table">
            <thead>
            </thead>
            <tbody>
              {renderUsers()}
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
      }
    </div>
  )
}
